import { InteractiveCanvasPane } from "./interactive-canvas-pane";

let canvasPaneInstance: InteractiveCanvasPane | null = null;

export const getCanvasPane = () => {
  if (!canvasPaneInstance)
    throw new Error("Cannot use InteractvieCanvasPane without initialisation");

  return canvasPaneInstance;
};

export const initialiseCanvasPane = (
  ...constructorArgs: ConstructorParameters<typeof InteractiveCanvasPane>
) => {
  canvasPaneInstance = new InteractiveCanvasPane(...constructorArgs);

  return canvasPaneInstance;
};
